import React from "react";

const OnboardingIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5625 0.9375H5.15625C4.78329 0.9375 4.4256 1.08566 4.16188 1.34938C3.89816 1.6131 3.75 1.97079 3.75 2.34375V12.6562C3.75 13.0292 3.89816 13.3869 4.16188 13.6506C4.4256 13.9143 4.78329 14.0625 5.15625 14.0625H9.84375C10.2167 14.0625 10.5744 13.9143 10.8381 13.6506C11.1018 13.3869 11.25 13.0292 11.25 12.6562V2.34375C11.25 1.97079 11.1018 1.6131 10.8381 1.34938C10.5744 1.08566 10.2167 0.9375 9.84375 0.9375H8.4375M6.5625 0.9375V1.875H8.4375V0.9375M6.5625 0.9375H8.4375M6.5625 12.6562H8.4375" stroke="#5C91FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  );
};

export default OnboardingIcon;
